import { render, staticRenderFns } from "./viewRequest.vue?vue&type=template&id=63865114&scoped=true"
import script from "./viewRequest.vue?vue&type=script&lang=js"
export * from "./viewRequest.vue?vue&type=script&lang=js"
import style0 from "./viewRequest.vue?vue&type=style&index=0&id=63865114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63865114",
  null
  
)

export default component.exports